export default __webpack_public_path__ + "static/media/miguel-lopes-6.fc642206.jpg";